import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { TArrayCodec, array } from "../../../shared/src/codecs/types/array";
import { TFormCodec, form } from "../../../shared/src/codecs/types/form";
import { TRequiredCodec, required } from "../../../shared/src/codecs/types/required";
import { EmptyObject, TEmptyObjectCodec } from "../EmptyObject";
import { Lender, TLenderCodec } from "../Lender";

export const LenderForm: TFormCodec<
    TLenderCodec,
    TEmptyObjectCodec
> = form(
    Lender,
    EmptyObject,
);
export type TLenderFormCodec = typeof LenderForm;
export type TLenderForm = TTypeOfCodec<TLenderFormCodec>;

export const LendersPageForm: TFormCodec<
    TEmptyObjectCodec,
    TRequiredCodec<{
        lender_forms: TArrayCodec<TLenderFormCodec>,
    }>
> = form(
    EmptyObject,
    required({
        lender_forms: array(LenderForm),
    }),
);
export type TLendersPageFormCodec = typeof LendersPageForm;
export type TLendersPageForm = TTypeOfCodec<TLendersPageFormCodec>;
